import type { SerializedEditorState } from "lexical";

/**
 * Compares a serialized editor state (e.g. from editorState.toJSON()) with a stored value
 * (e.g. from Formik). toJSON() returns a new object every time, so reference equality would
 * always be false even when content is unchanged (e.g. first blur after load).
 *
 * @param serialized - The current serialized state from the editor (object).
 * @param stored - The value currently stored (object, JSON string, or undefined/null).
 * @returns true if both represent the same content (no update needed).
 */
export function isSerializedEditorStateEqual(
  serialized: SerializedEditorState | string,
  stored: unknown
): boolean {
  const serializedStr =
    typeof serialized === "string" ? serialized : JSON.stringify(serialized);

  const storedStr =
    stored === undefined || stored === null
      ? ""
      : typeof stored === "string"
      ? stored
      : JSON.stringify(stored);
  return serializedStr === storedStr;
}
